// Global JavaScript
class CartNotification extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    if (event.target.classList.contains('cart-notification__close')) {
      this.close();
    }
  }

  open() {
    this.classList.add('active');
  }

  close() {
    this.classList.remove('active');
  }
}

if (!customElements.get('cart-notification')) {
  customElements.define('cart-notification', CartNotification);
}

// Smooth scroll for anchor links
document.addEventListener('DOMContentLoaded', function () {
  const anchorLinks = document.querySelectorAll('a[href^="#"]');

  anchorLinks.forEach(link => {
    link.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href !== '#' && href !== '') {
        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  });
});

// Add to cart functionality
class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    if (this.form) {
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    const submitButton = this.querySelector('[type="submit"]');

    if (submitButton.classList.contains('loading')) return;

    submitButton.classList.add('loading');
    submitButton.disabled = true;

    const formData = new FormData(this.form);

    const config = Object.assign({
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/javascript'
      },
      body: formData
    });

    // Force .js extension to ensure JSON response vs HTML Redirect
    const addUrl = window.routes.cart_add_url.endsWith('.js')
      ? window.routes.cart_add_url
      : `${window.routes.cart_add_url}.js`;

    fetch(addUrl, config)
      .then(response => {
        return response.text().then(text => {
          try {
            return JSON.parse(text);
          } catch (e) {
            console.error('JSON Parse Error:', e);
            console.error('Response Text:', text);
            throw new Error('Server returned non-JSON response. Check console for details.');
          }
        });
      })
      .then(data => {
        if (data.status === 422 || data.status === 400) {
          throw new Error(data.description || 'Invalid Request');
        }

        // Update cart
        this.handleSuccess(data);
      })
      .catch(error => {
        console.error('Error:', error);
        this.handleError(error.message);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.disabled = false;
      });
  }

  handleSuccess(data) {
    // Trigger custom event for cart update
    document.dispatchEvent(new CustomEvent('cart:item-added', {
      detail: { item: data }
    }));

    // Redirect to cart page for immediate feedback
    window.location.href = window.routes.cart_url || '/cart';
  }

  handleError(message) {
    alert(message || 'An error occurred. Please try again.');
  }
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', ProductForm);
}
